import { BaseUIService } from '@/modules/core/ui/services/BaseUIService';
import ModalService, { ModalOptions } from '@/modules/core/ui/services/ModalService';
import FinancialAdvisorProUpsellModal from '@/modules/financialadvisor/components/stateful/modals/FinancialAdvisorProUpsellModal.vue';
import FinancialAdvisorProUpsellModalV2 from '@/modules/financialadvisor/components/stateful/modals/FinancialAdvisorProUpsellModalV2.vue';
import { getters } from '@/modules/core/app/helpers/store';
import { AdvisorPortalEntryPoint } from '@/modules/financialadvisor/constants/AdvisorPortalEntryPoint';
import BaseFlowModal from '@/modules/core/form/components/BaseFlowModal.vue';
import { EstateType } from '@/modules/estate/enums/EstateType';
import { AdvisorPortalPlanningReferralStarted } from '@/modules/financialadvisor/models/segmentevents/AdvisorPortalPlanningReferralStarted';

export type AdvisorProUpsellModalParams = ModalOptions & {
  entryPoint?: string;
};

class FinancialAdvisorProUpsellButtonUIService extends BaseUIService {
  showUpsellModal(params: AdvisorProUpsellModalParams): void {
    const canAccessNewAdvisorProUpsellModal: boolean =
      getters.auth.getUser()?.permission?.canAccessNewAdvisorProUpsellModal ?? false;

    const onReferClientClicked: () => void = (): void => {
      this.showReferralFlowModal(params);
    };

    ModalService.show({
      parent: params.parent,
      component: canAccessNewAdvisorProUpsellModal
        ? FinancialAdvisorProUpsellModalV2
        : FinancialAdvisorProUpsellModal,
      fullScreen: true,
      props: {
        ...params.props,
        entryPoint: params.entryPoint ?? AdvisorPortalEntryPoint.NAV
      },
      events: {
        // V1 emits the legacy prefixed event name; V2 emits a no-prefix one
        // (vue-patterns.md §1.8). Both route to the shared referral flow.
        'on-refer-client-clicked': onReferClientClicked,
        'refer-client-clicked': onReferClientClicked
      }
    });
  }

  async showReferralFlowModal(params: AdvisorProUpsellModalParams): Promise<void> {
    ModalService.closeAll();

    const { ReferralReferClientFlowService } = await import(
      '@/modules/referral/services/ReferralReferClientFlowService'
    );

    if (params?.entryPoint) {
      AdvisorPortalPlanningReferralStarted.dispatch(params.entryPoint);
    }

    ModalService.show({
      parent: params?.parent,
      component: BaseFlowModal,
      props: {
        service: new ReferralReferClientFlowService().setEstateType(EstateType.CLEAR_VAULT),
        width: '60%'
      },
      fullScreen: true
    });
  }
}

export default new FinancialAdvisorProUpsellButtonUIService();
